module.exports = __webpack_public_path__ + "86699f93ada7b2c514564a770f872e9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/google_2023_chart.png
// module id = 1682
// module chunks = 0